










































import { Vue, Component, Prop } from 'vue-property-decorator'
import {
  MESSAGE_TYPE_NORMAL_SOUND_LEVEL,
  MESSAGE_TYPE_HARD_SOUND_LEVEL
} from '@/constants/message'
import WebSocketProvider from '@/websocket'
import { WebSocketMessageMode } from '@/websocket/constants'
import { WebSocketMessageMessageTypes } from '@/websocket/receivers/message'
import { ReceiveMessageBodyMessageMessage } from '@/websocket/receivers/message/receiveMessages'
import { ExStore } from 'vuex'
import { getEnvVar } from '@/utils'

@Component
export default class MessageReceiveModal extends Vue {
  @Prop({ type: Function, required: true })
  clickMoveToMessageHandler!: () => void

  $store!: ExStore
  webSokcet = WebSocketProvider.createConnection()
  receivedMessage: ReceiveMessageBodyMessageMessage | null = null
  showModal = false

  get loginUser() {
    return this.$store.getters['user/userInfo']
  }

  get senderUser() {
    if (!this.receivedMessage) {
      return ''
    }

    const { lastName, firstName, heartlineId } = this.receivedMessage.from

    if (heartlineId === getEnvVar('SYSTEM_USER_HL_ID')) {
      return `${lastName}${firstName}`
    }

    const occupationName =
      this.receivedMessage.fromOccupation.name || '（患者）'

    return `${lastName}${firstName}${occupationName}`
  }

  get messageContent() {
    if (!this.receivedMessage) {
      return ''
    }
    return this.receivedMessage.message.content
  }

  get isNormalSoundMessage() {
    return this.isSoundMessage(MESSAGE_TYPE_NORMAL_SOUND_LEVEL)
  }

  get isHardSoundMessage() {
    return this.isSoundMessage(MESSAGE_TYPE_HARD_SOUND_LEVEL)
  }

  isSoundMessage(level: number) {
    if (this.receivedMessage) {
      return this.receivedMessage.message.messageTypeLevel == level
    } else {
      return false
    }
  }

  handleReceiveMessage(message: ReceiveMessageBodyMessageMessage) {
    if (message.from.id === this.loginUser.id) {
      return
    }
    if (
      this.loginUser.isWorker &&
      this.$store.getters['appSettings/isOnline'] === false
    ) {
      this.$store.dispatch('message/updateUnreadHistory')
      return
    }
    this.receivedMessage = message
    this.showModal = true
  }

  handleClickClose() {
    if (this.receivedMessage) {
      const messageUser = this.receivedMessage.message.messageuserSet.find(
        ({ user }) => user.id === this.loginUser.id
      )
      if (messageUser) {
        this.$api.message.patchRead({
          id: messageUser.id,
          autoMarkAsRead: false
        })
      }
    }

    this.receivedMessage = null
    this.showModal = false
  }

  async handleClickMoveToMessage() {
    this.receivedMessage = null
    this.showModal = false
    this.clickMoveToMessageHandler()
  }

  created() {
    this.webSokcet.subscribeMessage(
      WebSocketMessageMode.MESSAGE,
      WebSocketMessageMessageTypes.MESSAGE,
      this.handleReceiveMessage.bind(this)
    )
    this.$postMessage.addEventListener('activateApp', () => {
      this.webSokcet = WebSocketProvider.createConnection()
    })
  }
}
